import { api } from "utils/apiClient";
import { ownerHeaders, setOwnerId } from "./ownerStorage";

function withOwner(options = {}) {
  return {
    ...options,
    headers: {
      ...ownerHeaders(),
      ...(options.headers || {}),
    },
  };
}

function rememberOwner(payload) {
  if (payload?.ownerId) setOwnerId(payload.ownerId);
  return payload;
}

export async function listConversations() {
  const data = await api.get("/api/v2/ask/conversations", withOwner());
  return Array.isArray(data) ? data : [];
}

export async function getConversation(id, options = {}) {
  return api.get(`/api/v2/ask/conversations/${id}`, withOwner(options));
}

export async function createConversation({
  message = "",
  seedOnly = false,
  creatorIds = [],
} = {}) {
  const data = await api.post(
    "/api/v2/ask/conversations",
    { message, seedOnly, creatorIds },
    withOwner(),
  );
  return rememberOwner(data);
}

export async function updateConversation(id, { creatorIds } = {}) {
  return api.patch(
    `/api/v2/ask/conversations/${id}`,
    { creatorIds },
    withOwner(),
  );
}

export async function deleteConversation(id) {
  return api.delete(`/api/v2/ask/conversations/${id}`, withOwner());
}

export async function createMessage(
  conversationId,
  { role, content, data, creatorIds } = {},
) {
  const payload = { role, content };
  if (data !== undefined) payload.data = data;
  if (Array.isArray(creatorIds)) payload.creatorIds = creatorIds;

  const result = await api.post(
    `/api/v2/ask/conversations/${conversationId}/messages`,
    payload,
    withOwner(),
  );
  return result?.message || result;
}
